import React from 'react'
import { createRoot } from 'react-dom/client';

import Ticker, {App} from './Ticker'

window.addEventListener('load', function () {
    const el = document.querySelector('#volitve_lokalne_2022_2')
    // const cel = document.querySelector('#volitve_lokalne_2022_2_container')
    // if(!el || !cel) return
    // try {
    //     const tickerdata = JSON.parse(el.textContent)
    //     createRoot(cel).render(<Ticker tickerdata={tickerdata}/>)
    // } catch (err) {
    //     console.error(err)
    // }

    const cel1 = document.querySelector('#volitve_lokalne_2022_2_experiment')
    if(!el || !cel1) return
    try {
        const tickerdata = JSON.parse(el.textContent)
        createRoot(cel1).render(<App tickerdata={tickerdata}/>)
    } catch (err) {
        console.error(err)
    }
});